/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { change, reduxForm, submit } from 'redux-form';
import PropTypes from 'prop-types';
import { ModalWindow } from '../../../../semantic-ui/components/modal-window';
import ModalFooterButtons from '../../../../semantic-ui/components/modal-window/modal-footer-buttons';
import { ADD_ADDRESS_FORM_NAME } from '../../constants';
import { AddressFormView } from './address-form-view';
import {
	createAddressAction,
	getAddressFormOptionsAction,
	setAddressFormOptionsAction,
	setAddressFormSearchValueAction,
} from '../../actions';
import {
	getFormattedAddressFormOptionsSelector,
	getAddressFormSearchValueSelector,
	getIsAddressFormOptionsLoadingSelector,
	getAddressFormOptionsSelector,
	getIsTimezonesLoadingSelector,
	getTimezonesSelector,
	getIsAddressInfoLoadingSelector,
} from '../../selectors';
import { validateAddressModal } from '../../utils';

const AddressModalWrapper = ({
	onSetIsModalShow,
	onSetIsContactModalShow,
	addressFormOptions,
	isAddressFormOptionsLoading,
	isAddressInfoLoading,
	addressFormSearchValue,
	onFormSubmit,
	onCreateAddress,
	onSetAddressFormSearchValue,
	onGetAddressFormOptions,
	onFieldChange,
	addresses,
	onSetAddressFormOptions,
	timezones,
	isTimezonesLoading,
}) => {
	const handleAddressSearchChange = ({ target: { value } }) => {
		onSetAddressFormSearchValue(value);
		onGetAddressFormOptions();
	};

	const handleAddressChange = value => {
		const currentAddress = addresses.find(address => address.value === value);

		if (currentAddress) {
			Object.entries(currentAddress.data).forEach(([key, value]) => {
				if (key !== 'timezone') {
					onFieldChange(ADD_ADDRESS_FORM_NAME, key, value);
				}
			});

			onFieldChange(ADD_ADDRESS_FORM_NAME, 'address', currentAddress.value);

			onSetAddressFormSearchValue(currentAddress.value);
		}
	};

	const handleModalClose = () => {
		onSetAddressFormOptions([]);
		onSetAddressFormSearchValue('');
		onSetIsModalShow(false);
	};

	const handleRedirect = () => {
		handleModalClose();

		onSetIsContactModalShow(true);
	};

	const handleAddressFormSubmit = async () => {
		await onFormSubmit(ADD_ADDRESS_FORM_NAME);

		onCreateAddress({ redirect: handleRedirect });
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' && e.shiftKey === false) {
			handleAddressFormSubmit();
		}
	};

	return (
		<ModalWindow
			isModalShown
			onKeyDown={handleKeyDown}
			onClose={handleModalClose}
			headerText="Создать адрес"
			modalContent={
				<AddressFormView
					addressFormOptions={addressFormOptions}
					isAddressFormOptionsLoading={isAddressFormOptionsLoading}
					onAddressSearchChange={handleAddressSearchChange}
					onAddressChange={handleAddressChange}
					addressFormSearchValue={addressFormSearchValue}
					timezones={timezones}
					isTimezonesLoading={isTimezonesLoading}
				/>
			}
			style={{ width: '900px' }}
			actionButtons={[{ type: 'close', onClick: handleModalClose, text: 'request-address' }]}
			footerButtons={
				<ModalFooterButtons
					leftButtons={[]}
					rightButtons={[
						{
							onClick: handleAddressFormSubmit,
							text: 'Сохранить',
							color: 'primary',
							loading: isAddressInfoLoading,
							disabled: isAddressInfoLoading,
						},
						{
							onClick: handleModalClose,
							text: 'Отмена',
							color: 'secondary',
							disabled: isAddressInfoLoading,
						},
					]}
				/>
			}
		/>
	);
};

const withForm = reduxForm({
	form: ADD_ADDRESS_FORM_NAME,
	enableReinitialize: true,
	onSubmit: validateAddressModal,
})(AddressModalWrapper);

const mapStateToProps = createStructuredSelector({
	addressFormOptions: getFormattedAddressFormOptionsSelector(),
	addressFormSearchValue: getAddressFormSearchValueSelector(),
	isAddressFormOptionsLoading: getIsAddressFormOptionsLoadingSelector(),
	isAddressInfoLoading: getIsAddressInfoLoadingSelector(),
	addresses: getAddressFormOptionsSelector(),
	timezones: getTimezonesSelector(),
	isTimezonesLoading: getIsTimezonesLoadingSelector(),
});

const mapDispatchToProps = {
	onFormSubmit: submit,
	onFieldChange: change,
	onSetAddressFormSearchValue: setAddressFormSearchValueAction,
	onGetAddressFormOptions: getAddressFormOptionsAction,
	onCreateAddress: createAddressAction,
	onSetAddressFormOptions: setAddressFormOptionsAction,
};

const AddressModal = connect(mapStateToProps, mapDispatchToProps)(withForm);

AddressModalWrapper.propTypes = {
	onSetIsModalShow: PropTypes.func.isRequired,
	onSetIsContactModalShow: PropTypes.func.isRequired,
	addressFormOptions: PropTypes.array.isRequired,
	addresses: PropTypes.array.isRequired,
	isAddressFormOptionsLoading: PropTypes.bool.isRequired,
	isAddressInfoLoading: PropTypes.bool.isRequired,
	addressFormSearchValue: PropTypes.string.isRequired,
	onFormSubmit: PropTypes.func.isRequired,
	onCreateAddress: PropTypes.func.isRequired,
	onSetAddressFormSearchValue: PropTypes.func.isRequired,
	onGetAddressFormOptions: PropTypes.func.isRequired,
	onFieldChange: PropTypes.func.isRequired,
	onSetAddressFormOptions: PropTypes.func.isRequired,
	isTimezonesLoading: PropTypes.bool.isRequired,
	timezones: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
};

export { AddressModal };
